import React, { useEffect, useState } from "react";
import Header from "../Home/header";
import Footer from "../Home/footer";
import Promotion from "../Home/Promotion";
import "../../css/header-menu/PowerManagement.css";

function ProductCard({ title, description, imgSrc, imgPosition = "left" }) {
    // imgPosition'a göre animasyon sınıfları
    const titleAnimClass = imgPosition === "left" ? "animate-from-right" : "animate-from-left";
    const paragraphAnimClass = "animate-from-bottom";

    return (
        <div className="Row">
            <div className="content-wrapper">
                {imgPosition === "left" && (
                    <div className="half image-container">
                        <img className="images" src={imgSrc} alt="Station" />
                    </div>
                )}
                <div className="half">
                    <div className="Column">
                        {/* Başlangıçta sadece hidden, hangi animasyon verileceğini data-anim ile belirt */}
                        <h1 className="HomeProductionsText hidden" data-anim={titleAnimClass}>{title}</h1>
                        <p className="homePage hidden" data-anim={paragraphAnimClass}>{description}</p>
                    </div>
                </div>
                {imgPosition === "right" && (
                    <div className="half image-container">
                        <img className="images" src={imgSrc} alt="Station" />
                    </div>
                )}
            </div>
        </div>
    );
}

function WhereCanYouPlace() {
    const Header1 = "Konut ve Toplu Yaşam Alanlarında";
    const Header2 = "Otel ve Otoparklarda";
    const Header3 = "Restoran ve Kafelerde";
    const Header4 = "İş Merkezi ve AVM'lerde";
    const Header5 = "Resmi Daire ve Kurumlarda";

    const Content1 = "Konutlar, toplu yaşam alanları, apartmanlar, siteler ya da rezidanslar için  elektrikli araç sahiplerine hizmet sunan DAP şarj istasyonlarıyla tanışın.\n" +
        "DAP özel çözümleri sayesinde elektrikli araçlarınızı zahmetsizce şarj edebilirsiniz.\n" +
        "Kurulum için daha fazla bilgi almak veya teklif almak için bize ulaşın.";

    const Content2 = "Otel ve konaklama tesislerinize DAP şarj istasyonları kurarak elektrikli araç sahibi misafirlerinize kusursuz bir deneyim sunabilirsiniz.\n" +
        "DAP şarj uygulaması ve web portalı üzerinden şarj süreçlerini yönetebilir ve takip edebilirsiniz.\n" +
        "Tesisinizde kurulum hizmeti veya detaylı bilgi için bizimle iletişime geçin.";

    const Content3 = "Restoran ve kafelerinize gelen elektrikli araç sahipleri için DAP şarj istasyonlarını tercih ederek konuklarınıza eşsiz bir konfor sunun.\n" +
        "Misafirleriniz yemeklerini keyifle yerken, araçlarının güvenle şarj edildiğinden emin olabilirler.\n" +
        "Şarj işlemlerini uygulama ve web portalı aracılığıyla kolayca yönetin. Daha fazla bilgi ve hizmet için bize ulaşın.";

    const Content4 = "Elektrikli araç kullanımının yaygınlaşmasıyla birlikte, iş yerleri ve alışveriş merkezlerinde şarj istasyonu bulundurma ihtiyacı giderek artmaktadır. DAP Şarj, kurumsal müşterilerimize özel çözümler sunarak şarj istasyonu ihtiyaçlarını karşılar. İhtiyaçlarınıza uygun çözümler ve detaylı bilgi için bizimle iletişime geçebilirsiniz";

    const Content5 = "Kamu kurumları, belediyeler ve resmi daireler için elektrikli araç şarj istasyonu çözümlerimizle, personel ve ziyaretçilere kolaylık sağlayabilirsiniz.\n" +
        "DAP şarj sunduğu yenilikçi çözümlerle şarj sürecinizi zahmetsizce tamamlayın.\n" +
        "Detaylı bilgi veya kurulum talebi için bize ulaşın.";

    useEffect(() => {
        const hiddenElements = document.querySelectorAll('.hidden');
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                const animClass = entry.target.getAttribute('data-anim');
                if (entry.isIntersecting) {
                    // Görünür alana girdi
                    entry.target.classList.remove('hidden');
                    if (animClass) {
                        entry.target.classList.add(animClass);
                    }
                } else {
                    // Görünür alandan çıktı
                    // Tekrar animasyon yapmak için tekrar .hidden ekleyip animClass'ı kaldırıyoruz.
                    entry.target.classList.add('hidden');
                    if (animClass) {
                        entry.target.classList.remove(animClass);
                    }
                }
            });
        }, {
            threshold: 0.1
        });

        hiddenElements.forEach(el => observer.observe(el));

        return () => {
            observer.disconnect();
        };
    }, []);

    return (
        <div>
            <Header />
            <Promotion
                Header=" Şarj İstasyonlarını Nerelerde Kullanabilirsiniz?"
                Footer=" Dap Şarj istasyonlarıyla yer mekan zaman farketmeksizin araçlarınızı şarj edebilir dur durak bilmeden yolculuğunuza devam edebilirsiniz."
                Footer2=" DAP şarj istasyonları, farklı alanlarda elektrikli araç sahiplerine hizmet sunmak üzere tasarlanmıştır. İşte DAP şarj istasyonlarını kullanabileceğiniz bazı alanlar:"
            />
            <SolutionsVideo />
            <ProductCard
                title={Header1}
                description={Content1}
                imgSrc="/assets/home/WCYU/first kopya.jpg"
                imgPosition="right"
            />
            <ProductCard
                title={Header4}
                description={Content4}
                imgSrc="/assets/home/WCYU/second.jpg"
                imgPosition="left"
            />
            <ProductCard
                title={Header2}
                description={Content2}
                imgSrc="/assets/home/WCYU/third kopya.jpg"
                imgPosition="right"
            />
            <ProductCard
                title={Header3}
                description={Content3}
                imgSrc="/assets/home/WCYU/fourth.png"
                imgPosition="left"
            />
            <ProductCard
                title={Header5}
                description={Content5}
                imgSrc="/assets/home/WCYU/fifth kopya.jpg"
                imgPosition="right"
            />
            <Footer />
        </div>
    );
}

const SolutionsVideo = () => {
    const [videoSource, setVideoSource] = useState('');

    useEffect(() => {
        const handleResize = () => {
            const isMobile = window.innerWidth <= 768;
            const baseUrl = process.env.PUBLIC_URL;
            setVideoSource(
                isMobile
                    ? `${baseUrl}/assets/videos/solutions_mobile.mp4`
                    : `${baseUrl}/assets/videos/solutions.mp4`
            );
        };

        handleResize(); // İlk yükleme için
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className="power-video-wrapper">
            {videoSource && (
                <video
                    key={videoSource} // Kaynak değiştiğinde video yeniden yüklenir
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="power-management-video"
                    disablePictureInPicture
                    controlsList="nodownload noplaybackrate"
                    style={{ backgroundColor: 'transparent' }}
                    src={videoSource}
                />
            )}
        </div>
    );
};

export default WhereCanYouPlace;
